import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import styles from "./Login.module.css";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase"; // ensure db is exported from firebase.js


export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const login = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!email || !password) {
      setErrorMsg("Please enter email and password");
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      if (!userCredential.user.emailVerified) {
        alert("Please verify your email before logging in.");
        await signOut(auth);
        return;
      }
await setDoc( doc(db, "users", userCredential.user.uid), { lastLoginAt: new Date().toISOString() }, { merge: true } );
      navigate("/dashboard");
    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.loginBox}>
        <h2 className={styles.title}>Login to Your Account</h2>

        <form onSubmit={login} className={styles.form}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            className={styles.input}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            className={styles.input}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
          />

          <button type="submit" className={styles.loginButton}>
            Login
          </button>

          {errorMsg && <p className={styles.errorMsg}>{errorMsg}</p>}
        </form>

        <button className={styles.btnBack} onClick={() => navigate("/")}>
          ← Back
        </button>
      </div>
    </div>
  );
}
